import "./Modal.scss";
import "./HolidayModal.scss";

import React, { useEffect } from "react";

function HolidayModal({
  holidayModalOpen,
  editingHolidayId,
  holidayForm,
  boats,
  allTimeSlots,
  allSummerTimeSlots,
  handleHolidayFormChange,
  handleHolidayPricingChange,
  onClose,
  onSaveHoliday,
}) {
  useEffect(() => {
    if (holidayModalOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [holidayModalOpen]);

  if (!holidayModalOpen) return null;

  return (
    <div
      className="popup-overlay-admin"
      onClick={(e) =>
        e.target.classList.contains("popup-overlay-admin") && onClose()
      }
    >
      <div className="popup-content large">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h1>{editingHolidayId ? "Edit Holiday" : "Add Holiday"}</h1>
        <div className="edit-info">
          <label>
            Holiday Name
            <input
              name="holiday_name"
              value={holidayForm.holiday_name}
              onChange={handleHolidayFormChange}
              placeholder="e.g. Summer Promotion"
            />
          </label>
          <label>
            Start Date
            <input
              type="date"
              name="start_date"
              value={holidayForm.start_date}
              onChange={handleHolidayFormChange}
            />
          </label>
          <label>
            End Date
            <input
              type="date"
              name="end_date"
              value={holidayForm.end_date}
              onChange={handleHolidayFormChange}
            />
          </label>
        </div>

        <div className="pricing-form">
          {boats && boats.map((boat) => {
            const boatPricing = holidayForm.pricing[boat._id] || {};
            const boatDests = boat.destinations || [];

            if (boatDests.length === 0) return null;

            return (
              <div key={boat._id} className="boat-pricing-block">
                <h2 className="boat-pricing-title">{boat.name}</h2>

                {boatDests.map((dest) => {
                  const destName = (dest.name || "").toLowerCase();
                  const isSlotBased = dest.isSlotBased !== undefined ? dest.isSlotBased : true;
                  const pricing = boatPricing[destName] || {};

                  return (
                    <React.Fragment key={destName}>
                      {/* Normal Season */}
                      <div className="pricing-section pricing-section-normal">
                        <h3>{dest.name}: Normal Season</h3>
                        <div className="pricing-grid">
                          {isSlotBased ? (
                            <>
                              {allTimeSlots && allTimeSlots.map((slot, idx) => (
                                <label key={`${destName}-slot${idx + 1}`}>
                                  {slot.label || `Slot ${idx + 1}`} (EGP)
                                  <input
                                    type="number"
                                    min="0"
                                    value={pricing[`slot${idx + 1}`] || 0}
                                    onChange={(e) =>
                                      handleHolidayPricingChange(boat._id, destName, `slot${idx + 1}`, e.target.value)
                                    }
                                  />
                                </label>
                              ))}
                              <label>
                                Full Day (EGP)
                                <input
                                  type="number"
                                  min="0"
                                  value={pricing.fullDay || 0}
                                  onChange={(e) =>
                                    handleHolidayPricingChange(boat._id, destName, "fullDay", e.target.value)
                                  }
                                />
                              </label>
                              {allTimeSlots && allTimeSlots.length >= 2 && (
                                <label>
                                  2-Slot Bundle (EGP)
                                  <input
                                    type="number"
                                    min="0"
                                    value={pricing.twoSlot || 0}
                                    onChange={(e) =>
                                      handleHolidayPricingChange(boat._id, destName, "twoSlot", e.target.value)
                                    }
                                  />
                                </label>
                              )}
                            </>
                          ) : (
                            <>
                              <label>
                                Full Trip (EGP)
                                <input
                                  type="number"
                                  min="0"
                                  value={pricing.full || 0}
                                  onChange={(e) =>
                                    handleHolidayPricingChange(boat._id, destName, "full", e.target.value)
                                  }
                                />
                              </label>
                              <label>
                                Drop-off Only (EGP)
                                <input
                                  type="number"
                                  min="0"
                                  value={pricing.dropOff || 0}
                                  onChange={(e) =>
                                    handleHolidayPricingChange(boat._id, destName, "dropOff", e.target.value)
                                  }
                                />
                              </label>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Summer Season */}
                      <div className="pricing-section pricing-section-summer">
                        <h3>{dest.name}: Summer Season</h3>
                        <div className="pricing-grid">
                          {isSlotBased ? (
                            <>
                              {allSummerTimeSlots && allSummerTimeSlots.map((slot, idx) => (
                                <label key={`${destName}-summer-slot${idx + 1}`}>
                                  {slot.label || `Slot ${idx + 1}`} (EGP)
                                  <input
                                    type="number"
                                    min="0"
                                    value={pricing[`summer_slot${idx + 1}`] || 0}
                                    onChange={(e) =>
                                      handleHolidayPricingChange(boat._id, destName, `summer_slot${idx + 1}`, e.target.value)
                                    }
                                  />
                                </label>
                              ))}
                              <label>
                                Full Day (EGP)
                                <input
                                  type="number"
                                  min="0"
                                  value={pricing.summer_fullDay || 0}
                                  onChange={(e) =>
                                    handleHolidayPricingChange(boat._id, destName, "summer_fullDay", e.target.value)
                                  }
                                />
                              </label>
                            </>
                          ) : (
                            <>
                              <label>
                                Full Trip (EGP)
                                <input
                                  type="number"
                                  min="0"
                                  value={pricing.summer_full || 0}
                                  onChange={(e) =>
                                    handleHolidayPricingChange(boat._id, destName, "summer_full", e.target.value)
                                  }
                                />
                              </label>
                              <label>
                                Drop-off Only (EGP)
                                <input
                                  type="number"
                                  min="0"
                                  value={pricing.summer_dropOff || 0}
                                  onChange={(e) =>
                                    handleHolidayPricingChange(boat._id, destName, "summer_dropOff", e.target.value)
                                  }
                                />
                              </label>
                            </>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            );
          })}
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="save-btn" onClick={onSaveHoliday}>
            Save Holiday
          </button>
        </div>
      </div>
    </div>
  );
}

export default HolidayModal;
